/* ⚛ REACT */
import { useState } from "react";

/* 📦 LIBS */
import { useTranslation } from "react-i18next";

/* 🧩 COMPONENTS */
import InputCheckboxFilter from "../InputCheckboxFilter";

/* 🎨 STYLES */
import { Container, Sidebar, RadioButton, Content, ContainerOption, RadioButtonLabel, Bar } from "./styles";

const Filters = ({options, OptionContent, ChangeFilter, visible}) => {

    const { t } = useTranslation();

    const [selectedOption, setSelectedOption] = useState(options[0]?.id);
    const [loadingOptions, setLoadingOptions] = useState(false);

    const handleOptionChange = (event) => {
        setLoadingOptions(true);
        setSelectedOption(event.target.value);
        setTimeout(() => {
            setLoadingOptions(false);
        }, 10);
    };

    return (
        <Container $visible={visible}>
            <Sidebar>
                {options.map((option) => (
                    <ContainerOption key={option.id}>
                        <RadioButton
                        id={option.id}
                        value={option.id}
                        checked={selectedOption === option.id}
                        onChange={handleOptionChange}
                        />
                        <RadioButtonLabel checked={selectedOption === option.id} htmlFor={option.id}>{t(`filter-button.options.${option.label}`)}</RadioButtonLabel>
                    </ContainerOption>
                ))}
            </Sidebar>
            <Bar/>
            <Content>
                {
                    !loadingOptions ? OptionContent[selectedOption]?.map((option, index) => (
                        <InputCheckboxFilter key={index} text={option.title ? option.title : option.subtitle ? option.subtitle : option.nome} checked={option.value} 
                        onChange={(value)=> {
                            option.value = value
                            ChangeFilter(selectedOption, option.id, value)
                        }}
                        />
                    ))
                    : null
                }
            </Content>
        </Container>
    );
};

export default Filters;